<template>
    <h4 class="m-heading-form">
        {{text}}
        <span v-if="label === 'required'" class="m-heading-form-label is-required">必須</span>
        <span v-if="label === 'any'" class="m-heading-form-label is-any">任意</span>
    </h4>
</template>

<script>
    export default {
        name: "HeadingFormLabel",
        props: {
            /**
             * 見出しにするテキスト
             */
            text: {
                type: String,
                required: true
            },
            /**
             * 「必須(required)」か「任意(any)」を選択
             */
            label: {
                type: String,
                required: false,
                default: ""
            }
        }
    }
</script>

<style scoped lang="scss">
@use "../../../scss/v2/base/variables";

    .m-heading-form {
        display: inline-block;
        font-size: 1rem;
        font-weight: bold;
        position: relative;
        margin-bottom: 8px;
        &-label {
            background: variables.$color-white;
            font-size: 1rem;
            color: variables.$color-white;
            padding: 2px 4px;
            margin-left: 8px;
            &.is-required { //必須ラベル
                background: variables.$color-important;
            }
            &.is-any { //任意ラベル
                background: variables.$color-pictlink-black-50;
            }
        }
    }
</style>
